export { default } from './internal/removable';
export type { RemovableTagProps } from './internal/removable';
